const comments = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Asian%20man%20with%20friendly%20smile%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20natural%20expression%2C%20headshot%20photography&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '影迷小张',
    time: '2小时前',
    content: '白云视频真的太良心了！资源更新快，画质也清晰，周末一口气刷完了整部《长安风云录》，完全不卡顿。已经推荐给身边的朋友了！',
    likes: 328,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Asian%20woman%20with%20warm%20smile%2C%20clean%20studio%20background%2C%20soft%20lighting%2C%20natural%20expression%2C%20headshot%20photography&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '剧荒拯救者',
    time: '5小时前',
    content: '之前用了好几个平台，不是卡就是广告多。白云视频体验确实不错，片库也够大，从韩剧到美剧到国产剧都有，基本满足日常追剧需求。',
    likes: 256,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20middle-aged%20Asian%20man%20with%20gentle%20smile%2C%20clean%20studio%20background%2C%20warm%20lighting%2C%20natural%20expression%2C%20headshot%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '老电影爱好者',
    time: '1天前',
    content: '作为一个看了20年电影的老影迷，白云视频的资源深度让我惊喜。不仅新片更新快，很多经典老片也能找到，值得长期收藏使用。',
    likes: 189,
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 rounded-full bg-primary-500"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            影迷之声
          </h2>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {comments.map((comment, idx) => (
            <div
              key={idx}
              className="bg-background-100 rounded-xl border border-background-200/60 p-5 md:p-6"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <div className="text-sm font-semibold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-400">{comment.time}</div>
                </div>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">{comment.content}</p>
              <div className="flex items-center gap-4 mt-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes}
                </span>
                <span className="cursor-pointer hover:text-primary-500 transition-colors">
                  <i className="ri-chat-1-line mr-1"></i>回复
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}